import { FlagIcon } from '@heroicons/react/20/solid'

export function RedFlagIcon() {
  return (
    <FlagIcon
      width={18}
      height={18}
      color='red'
      className='ml-2'
    />
  )
}
